import React, { Component } from 'react';
import { Field } from 'redux-form';

import TextInput from './TextInput';
import CheckboxInput from './CheckboxInput';
import Dropdown from './Dropdown';
import RadioInput from './RadioInput';
import { required } from '../../../utils/validators';
import countries from './countries.json';

type Props = {
    registerFields: array,
    name: string,
    active: boolean,
    primaryColor: string,
    handleFocus: Function,
};

export default class registerFields extends Component<Props> {
    constructor(props) {
        super(props);

        this.state = {
            hover: {},
        };
    }

    toggleHover = name => {
        let hasHover = {};
        hasHover[name] = this.state.hover[name]
            ? !this.state.hover[name]
            : true;
        this.setState({
            hover: hasHover,
        });
    };

    render() {
        return this.props.registerFields ? (
            this.props.registerFields.map(field => {
                const iconName =
                    field.name !== 'fullname' &&
                    field.name !== 'surname' &&
                    field.name !== 'first_name'
                        ? 'default_icon'
                        : '';
                switch (field.type) {
                    case 'input':
                        return (
                            <Field
                                key={field.id}
                                component={TextInput}
                                type="text"
                                name={field.name}
                                iconName={iconName}
                                label={
                                    field.required
                                        ? `${field.placeholder.toLowerCase()}*`
                                        : field.placeholder.toLowerCase()
                                }
                                className="labelholder registerfield"
                                validate={field.required ? [required] : []}
                                handleFocus={this.props.handleFocus}
                                active={
                                    this.props.name === field.name
                                        ? this.props.active
                                        : false
                                }
                                primaryColor={this.props.primaryColor}
                            />
                        );
                    case 'checkbox':
                        return (
                            <Field
                                key={field.id}
                                fieldKey={field.id}
                                component={CheckboxInput}
                                name={field.name}
                                className="registerfield checkholder"
                                type="checkbox"
                                labelClass="checklabel"
                                firstLabelClass="radiolabel"
                                label={
                                    field.label
                                        ? `${field.label}${
                                              field.required ? '*' : ''
                                          }`
                                        : field.label
                                }
                                validate={field.required ? [required] : []}
                                primaryColor={this.props.primaryColor}
                                toggleHover={this.toggleHover}
                                hover={this.state.hover}
                            />
                        );
                    case 'select':
                        return (
                            <Field
                                key={field.id}
                                component={Dropdown}
                                name={field.name}
                                iconName={iconName}
                                className="registerfield selectholder"
                                label={
                                    field.required
                                        ? `${field.placeholder.toLowerCase()}*`
                                        : field.placeholder.toLowerCase()
                                }
                                options={field.options}
                                validate={field.required ? [required] : []}
                                primaryColor={this.props.primaryColor}
                            />
                        );
                    case 'radio':
                        return (
                            <Field
                                key={field.id}
                                fieldKey={field.id}
                                component={RadioInput}
                                name={field.name}
                                className="registerfield radioholder"
                                label={
                                    field.label
                                        ? `${field.label}${
                                              field.required ? '*' : ''
                                          }`
                                        : field.label
                                }
                                options={field.options}
                                labelClass="radiolabel"
                                inputClassName="radioinput"
                                validate={field.required ? [required] : []}
                                primaryColor={this.props.primaryColor}
                            />
                        );
                    case 'country':
                        return (
                            <Field
                                key={field.id}
                                component={Dropdown}
                                name={field.name}
                                iconName="location"
                                type="country"
                                className="registerfield selectholder"
                                label={
                                    field.required
                                        ? `${field.placeholder.toLowerCase()}*`
                                        : field.placeholder.toLowerCase()
                                }
                                options={countries}
                                validate={field.required ? [required] : []}
                                primaryColor={this.props.primaryColor}
                            />
                        );
                    default:
                        return null;
                }
            })
        ) : (
            <div />
        );
    }
}



// WEBPACK FOOTER //
// ./src/ui/components/Inputs/RegisterFieldsInput.js